import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, ProtectedRoute } from '@es-tools/shared';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import HolyShipped from './pages/HolyShipped';
import AutomationLibrary from './pages/AutomationLibrary';
import DataPlatformGuide from './pages/DataPlatformGuide';

const DEFAULT_ALLOWED_EMAIL_DOMAINS = [
  'hirehoratio.co',
  'mengotomars.com',
  'hollowsocks.com',
  'easystreetbrands.com',
  'paradigmcapital.xyz',
];

const parseAllowedDomains = (rawValue?: string): string[] => {
  const source = rawValue ?? DEFAULT_ALLOWED_EMAIL_DOMAINS.join(',');
  return source
    .split(',')
    .map((domain) => domain.trim().toLowerCase())
    .filter((domain) => domain.length > 0);
};

const allowedDomains = parseAllowedDomains(import.meta.env.VITE_ALLOWED_EMAIL_DOMAINS);

type AppProps = {
  authApiBaseUrl: string;
};

function App({ authApiBaseUrl }: AppProps) {
  const devBypassEnabled = import.meta.env.VITE_DEV_BYPASS_AUTH === 'true';

  return (
    <AuthProvider
      allowDevBypass={devBypassEnabled}
      allowedDomains={allowedDomains}
      authApiBaseUrl={authApiBaseUrl}
    >
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/holy-shipped"
            element={
              <ProtectedRoute>
                <HolyShipped />
              </ProtectedRoute>
            }
          />
          <Route
            path="/holy-shipped/week/:weekNumber"
            element={
              <ProtectedRoute>
                <HolyShipped />
              </ProtectedRoute>
            }
          />
          <Route
            path="/automation-library"
            element={
              <ProtectedRoute>
                <AutomationLibrary />
              </ProtectedRoute>
            }
          />
          <Route
            path="/data-platform"
            element={
              <ProtectedRoute>
                <DataPlatformGuide />
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
